module.exports = __webpack_public_path__ + "img/report-header.ad1585d7.png";